import renderBenefitPlanPage from "../../../infrastructure/renders/BenefitPlanPage/render-benefit-plan-page";

export default async function modifyBenefitPlanEmployees({
  benefitPlan,
  availableFilters,
  currentFilters,
  employees,
  totalEmployees,
  whichEmployees,
  value,
}) {
  let newestSelection = [];
  if (whichEmployees === "all") {
    renderBenefitPlanPage({
      benefitPlan: benefitPlan.modEmployees(
        employees.filter(({ checked }) => checked)
      ),
      availableFilters,
      currentFilters,
      employees: newestSelection,
      totalEmployees,
    });
    newestSelection = employees.map((employee) => ({
      ...employee,
      checked: value,
    }));
  } else {
    newestSelection = employees.map((employee) => ({
      ...employee,
      checked: whichEmployees === employee.id ? value : employee.checked,
    }));
  }

  renderBenefitPlanPage({
    benefitPlan: benefitPlan.modEmployees(
      newestSelection.filter(({ checked }) => checked)
    ),
    availableFilters,
    currentFilters,
    employees:
      whichEmployees === "all"
        ? employees.map((employee) => ({ ...employee, checked: value }))
        : newestSelection,
    totalEmployees,
  });
}
